import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-password-alert',
  templateUrl: './change-password-alert.component.html',
  styleUrls: ['./change-password-alert.component.scss'],
})
export class ChangePasswordAlertComponent implements OnInit {
  constructor(public modalService: NgbModal, private router: Router) {}

  ngOnInit(): void {
    this.navigateUser();
  }

  navigateUser = () => {
    setTimeout(() => {
      this.router.navigate(['/signin']);
      this.modalService.dismissAll();
    }, 5000);
  };
}
